import { Box, css, keyframes, styled, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { ReactComponent as WideArrowDownIcon } from '@assets/icons/wide-arrow-down.svg';

const ARROW_TEXT_HEIGHT = pxToRem(35);
const ARROW_CONTAINER_HEIGHT = pxToRem(49);
const ARROW_ICON_HEIGHT = pxToRem(15);
const ARROW_BOUNCE_OFFSET = pxToRem(23);

const fadeOut = keyframes`
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
`;

const fadeIn = keyframes`
  0% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
`;

const arrowBounce = keyframes`
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-${ARROW_BOUNCE_OFFSET});
  }
  60% {
    transform: translateY(-${ARROW_BOUNCE_OFFSET});
  }
`;

const fadeInMixin = () => css`
  ${fadeIn} 500ms forwards 1.5s;
`;

const fadeOutMixin = () => css`
  ${fadeOut} 500ms forwards 0.3s;
`;

export const StyledBoxViewDetails = styled(Box)<{ show: boolean }>`
  animation: ${({ show }) => (show ? fadeInMixin : fadeOutMixin)};
  // Initial opacity is inverted: 0 when showing (animates to 1), 1 when hiding (animates to 0)
  opacity: ${({ show }) => (show ? 0 : 1)};
  ${({ show }) =>
    !show &&
    css`
      transition: visibility 0s ease 1.5s;
      visibility: hidden;
    `}
`;

export const StyledBoxArrowIcon = styled(WideArrowDownIcon)`
  opacity: 0.8;
  height: ${ARROW_ICON_HEIGHT};
  line-height: ${ARROW_ICON_HEIGHT};
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  overflow: hidden;
  animation: ${arrowBounce} 4s ease-out 1.5s infinite;
`;

export const StyledBoxText = styled(TextV2)`
  height: ${ARROW_TEXT_HEIGHT};
  text-align: center;
  color: inherit;
  line-height: ${ARROW_TEXT_HEIGHT};
`;

export const StyledBoxArrow = styled(Box)`
  height: ${ARROW_CONTAINER_HEIGHT};
  text-align: center;
  position: relative;
  margin: 0 auto;
  color: inherit;
`;
